import { Settings } from 'handsontable/plugins/dropdownMenu';

import { DEFAULT_TEXT_STYLE, chartColorPalette } from '../ChartWidget.config';
import { extendSeriesData } from '../ChartWidget.helpers';
import { ChartDataSeries, ControlledHeader } from '../ChartWidget.types';

const DEFAULT_WIDTH = 480;
const DEFAULT_HEIGHT = 300;

const DEFAULT_ENABLE_Y1_AXIS_LINE = false;
const DEFAULT_ENABLE_Y2_AXIS_LINE = false;

const DEFAULT_COMBO_CHART_DATA = {
  generalOptions: {
    binSize: 10,
    borderColor: '#FFF',
    borderWidth: 1,
    innerSize: 0,
  },
  legend: {
    enabled: false,
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  dataLabels: {
    enabled: true,
    style: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  xAxis: {
    title: {
      text: 'Year',
      style: {
        ...DEFAULT_TEXT_STYLE,
        fontWeight: 'bold',
      },
    },
    style: {
      lineColor: '#000',
      lineWidth: 1,
    },
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  yAxis: {
    title: {
      text: 'Sales',
      style: {
        ...DEFAULT_TEXT_STYLE,
        fontWeight: 'bold',
      },
    },
    enableLine: DEFAULT_ENABLE_Y1_AXIS_LINE,
    style: {
      lineColor: '#000',
      lineWidth: 1,
    },
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  y2Axis: {
    title: {
      text: 'Conversion rate (%)',
      style: {
        ...DEFAULT_TEXT_STYLE,
        fontWeight: 'bold',
      },
    },
    enableLine: DEFAULT_ENABLE_Y2_AXIS_LINE,
    style: {
      lineColor: '#000',
      lineWidth: 1,
    },
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  grid: {
    style: {
      lineColor: '#DBDBDB',
    },
  },
  seriesData: extendSeriesData([
    {
      data: ['2021', '2022', '2023', '2024', '2025'],
    },
    {
      name: 'Sales',
      controlledHeader: ControlledHeader.ComboColumn,
      data: ['14000', '15000', '16000', '17500', '18500'],
    },
    {
      name: 'Conversion rate',
      controlledHeader: ControlledHeader.ComboLine,
      data: ['4.2', '4.7', '6.4', '7.5', '7'],
    },
  ] as ChartDataSeries),
  seriesMeta: {
    colors: chartColorPalette,
  },
};

const DROPDOWN_MENU_SETTINGS: Settings = {
  items: {
    y1: {
      key: ControlledHeader.ComboColumn,
      name: ControlledHeader.ComboColumn,
    },
    y2: {
      key: ControlledHeader.ComboLine,
      name: ControlledHeader.ComboLine,
    },
  },
};

export {
  DEFAULT_COMBO_CHART_DATA,
  DEFAULT_ENABLE_Y1_AXIS_LINE,
  DEFAULT_ENABLE_Y2_AXIS_LINE,
  DEFAULT_HEIGHT,
  DEFAULT_WIDTH,
  DROPDOWN_MENU_SETTINGS,
};
